<template>
  <v-card class="homepage-v-card" v-if="event">
  <v-card-text>
    <div class="glass-element event-title-container data-container">
      <div align="center">
        <h1 class="container-title">
          <v-icon v-if="event.event_private"
            >mdi-archive-lock-open-outline</v-icon
          >
          {{ event.event_title }}
        </h1>
        <v-btn color="primary" @click="join" v-if="canJoin">Join</v-btn>
        <v-btn color="primary" @click="leave" v-if="isAllowed">Leave</v-btn>
      </div>
      <v-row align="center" class="data-container-content">
        <v-col>
          <h4>From</h4>
          <v-icon>mdi-calendar</v-icon>
          {{ event.event_datetime_start | parseDateTime }}
        </v-col>
        <v-col v-if="event.event_datetime_end">
          <h4>To</h4>
          <v-icon>mdi-alarm</v-icon>
          {{ event.event_datetime_end | parseDateTime }}
        </v-col>
        <v-col>
          <v-icon>mdi-home-account</v-icon>
          Hosted by
          {{ event.event_host.username }}
        </v-col>
        <v-col>
          <v-icon>mdi-account-group</v-icon>
          {{ event.event_min_participants }}
          <span v-if="event.event_max_participants"
            >- {{ event.event_max_participants }}
          </span>
        </v-col>
      </v-row>
    </div>
    <div class="glass-element data-container">
      <h2 class="container-title">Event description</h2>
      <div class="data-container-content">
        <p>{{ event.event_description }}</p>
      </div>
    </div>

    <div
      class="glass-element data-container"
      style="position: relative"
      v-if="event.event_address"
    >
      <h2 class="container-title">
        Adress: {{ event.event_address }}
        <small>
          <a
            rel="noreferrer noopener"
            class="direction-link"
            :href="`https://www.google.com/maps/dir//${event.event_address
              .split(' ')
              .join('+')}`"
            target="_blank"
          >
            Itinery
            <v-icon>mdi-map</v-icon>
          </a>
        </small>
      </h2>
    </div>
    <div class="glass-element data-container" v-if="isAllowed">
      <h2 class="container-title">Games and others (food, drink, etc...)</h2>
      <div class="data-container-content">
        <div :key="key" v-for="(this_user, key) of event_items">
          <p :key="c.item_id" v-for="c of this_user">
            <span style="font-weight: bold">{{ c.item_name }}</span>
            <span v-if="c.item_event_type && c.item_event_type.event_type_name">
              ({{ c.item_event_type.event_type_name }}) by {{ key }}
            </span>
            <v-btn
              @click="removeItem(c.item_id)"
              v-if="key == ownProfile.username"
            >
              Remove
            </v-btn>
          </p>
        </div>
        <v-dialog v-model="itemsDialog">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
              Bringing something?
            </v-btn>
          </template>

          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Bring new stuff to an event
            </v-card-title>

            <v-card-text>
              <ItemsList :items="miscellaneous" :event="event" />
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="itemsDialog = false">
                Done
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>

    <div class="glass-element data-container" v-if="isAllowed">
      <h2 class="container-title">
        Comments
        <v-btn @click="showCommentForm = true" v-if="!showCommentForm">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn @click="showCommentForm = false" v-if="showCommentForm">
          <v-icon>mdi-archive-arrow-up</v-icon></v-btn
        >
      </h2>
      <v-card class="glass-element" v-if="showCommentForm">
        <v-form>
          <v-textarea
            placeholder="Add your comment"
            rows="5"
            class="input"
            v-model="comment"
          >
          </v-textarea>
          <v-btn
            v-if="this.comment && this.comment.length > 0"
            class="form-actions first-action"
            @click="saveComment"
            >Send</v-btn
          >
        </v-form>
      </v-card>
      <div class="data-container-content">
        <p :key="c.id" v-for="c in comments">
          <span style="font-weight: bold">
            {{ c.created_at | parseDateTime }} {{ c.profile.username }}:
          </span>
          {{ c.message }}
        </p>
      </div>
    </div>
    <div class="glass-element data-container">
      <h2 class="container-title">Invitations</h2>
      <div class="data-container-content">
        <InvitationCard :key="i.id" v-for="i in invitations" :invitation="i" />
        <p v-if="invitations && invitations.length === 0">No invitations yet</p>
        <v-dialog
          v-model="invitationsDialog"
          v-if="event.event_host.id === ownProfile.id"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
              Invite more people!
            </v-btn>
          </template>

          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Add new people to be invited
            </v-card-title>

            <v-card-text>
              <InviteForm
                :event_id="event.event_id"
                :event_slug="event.event_slug"
              />
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="invitationsDialog = false">
                Done
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
    </v-card-text>
  </v-card>
</template>

<script>

import ItemsList from "@/components/atoms/ItemsList";
import InvitationCard from "@/components/atoms/InvitationCard";
import { mapState } from "vuex";
import { parseDateTime } from "@/utils";
import InviteForm from "@/components/molecules/InviteForm";

export default {
  components: {
    InvitationCard,
    ItemsList,
    InviteForm,
  },
  data() {
    return {
      showCommentForm: false,
      showMiscellaneous: false,
      showGames: false,
      comment: null,
      loading: false,
      showInvite: false,
      invitationsDialog: false,
      itemsDialog: false,
    };
  },
  computed: mapState({
    comments(state) {
      return state.comments.comments?.filter(
        (e) => e.event === this.event.event_id
      );
    },
    ownProfile: (state) => state.profiles.ownProfile,
    event: (state) => state.events.currentEvent,
    invitations: (state) => state.events.currentEvent.invitations,
    miscellaneous: (state) => state.items.miscellaneous,
    games: (state) => state.items.games,
    event_items: (state) => {
      let items = {};

      for (const invitation of state.events.currentEvent.invitations) {
        items[invitation.invitee.username] = invitation.items.filter(e => e.item_status == 'PU');
      }
      return items;
    },
    canJoin: (state) => {
      // If no invitation exists, allow to join.
      if (
        !state.events.currentEvent.invitations.find(
          (e) => e.invitee.id == state.profiles.ownProfile.id
        )
      ) {
        return true;
      }
      // If invitation exists but not with status accepted or host allows to join.
      for (const invitation of state.events.currentEvent.invitations) {
        if (
          invitation.invitee.id == state.profiles.ownProfile.id &&
          (invitation.status == "AC" || invitation.status == "HO")
        ) {
          return false;
        }
      }
      return true;
    },
    isAllowed(state) {
      let temInvitation = state.events.currentEvent.invitations.filter(
        (e) =>
          e.invitee.id == this.ownProfile.id &&
          (e.status == "AC" || e.status == "HO")
      );
      return temInvitation.length > 0;
    },
  }),
  filters: {
    parseDateTime,
  },
  methods: {
    async removeItem(item_id) {
      for (const invitation of this.invitations) {
        if (invitation.invitee.id == this.ownProfile.id) {
          invitation.items = invitation.items.filter(
            (item) => item.item_id != item_id
          );
          invitation.items = invitation.items.map((item) => item.item_id);
          invitation.inv_event = invitation.inv_event.event_id;
          invitation.invitee = invitation.invitee.id;
          await this.$store.dispatch("updateInvitations", {
            ...invitation,
          });
          this.$store.dispatch("eventDetails", this.event.event_slug);
        }
      }
    },
    async saveComment() {
      this.loading = true;
      const success = await this.$store.dispatch("addComment", {
        message: this.comment,
        profile: this.ownProfile.id,
        event: this.event.event_id,
      });
      if (success) this.close();
      this.loading = false;
      this.showCommentForm = false;
    },
    close() {
      this.comment = null;
      this.showCommentForm = false;
      this.$store.commit("SET_CURRENT_INVITATION", null);
    },
    displayCommentForm() {
      this.showCommentForm = true;
    },
    async join() {
      // If no invitation exists, create one.
      let invitation = this.invitations.find(
        (e) => e.invitee.id == this.ownProfile.id
      );
      if (typeof invitation == "undefined") {
        let invitation = {};
        invitation.status = "AC";
        invitation.inv_event = this.event.event_id;
        invitation.invitee = this.ownProfile.id;
        this.$store.dispatch("createInvitation", invitation);
        this.reset();
        return;
      }
      invitation.inv_event = this.event.event_id;
      invitation.invitee = this.ownProfile.id;
      invitation.status = "AC";
      invitation.items = [];
      delete invitation.created_at;
      delete invitation.updated_at;
      await this.$store
        .dispatch("updateInvitations", invitation)
        .then(() => this.reset());
      // window.location.reload();
    },
    async leave() {
      let invitation = this.invitations.find(
        (e) => e.invitee.id == this.ownProfile.id
      );
      invitation.status = "RE";
      invitation.inv_event = this.event.event_id;
      invitation.invitee = this.ownProfile.id;
      invitation.items = invitation.items.map((e) => e.item_id);
      invitation.games = invitation.games.map((e) => e.item_id);
      await this.$store
        .dispatch("updateInvitations", invitation)
        .then(() => this.reset());
    },
    reset() {
      this.$store.commit("SET_CURRENT_EVENT", null);
      const eventSlug = this.$route.params.event_slug;
      this.$store.dispatch("eventDetails", eventSlug);
      this.$store.dispatch("getComments");
      // this.$store.dispatch("getOwnProfile");
    },
  },
  mounted() {
    this.reset();
  },
};
</script>


<style scoped>
.data-container {
  margin: 40px;
  min-height: 10px;
}
.data-container .container-title {
  background: white;
  border-radius: 24px 24px 0 0;
  padding: 12px 24px;
}
.data-container .data-container-content {
  padding: 12px 24px;
  margin: 10px;
}
.event-title-container i {
  color: grey !important;
}
.event-title-container h1 {
  font-weight: 300;
  font-size: 3rem;
  text-align: center;
}
.homepage-v-card{
      background: transparent;
    border: none;
    box-shadow: none!important;
}
</style>